<template>
    <div>
        <!-- Sidebar -->
        <div class="sidebar" id="sidebar">
            <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-x="scrollHanle">
                <div class="sidebar-menu">
                    <ul>
                        <li class="index"> 
                          <router-link to="/index"><i class="la la-home"></i> <span>Back to Home</span></router-link>
                        </li>
                        <li class="menu-title">Settings</li>
                        <li class="settings" :class="{'active': currentpage === 'settings'}"> 
                          <router-link to="/settings"><i class="la la-building"></i> <span>Company Settings</span></router-link>
                        </li>
                        <li class="localization" :class="{'active': currentpage === 'localization'}"> 
                          <router-link to="/localization"><i class="la la-clock-o"></i> <span>Localization</span></router-link>
                        </li>
                        <li class="themesettings" :class="{'active': currentpage === 'themesettings'}"> 
                          <router-link to="/themesettings"><i class="la la-photo"></i><span>Theme Settings</span></router-link>
                        </li>
                        <li class="rolespermissions" :class="{'active': currentpage === 'rolespermissions'}"> 
                          <router-link to="/rolespermissions"><i class="la la-key"></i> <span>Roles & Permissions</span></router-link>
                        </li>
                        <li class="emailsettings" :class="{'active': currentpage === 'emailsettings'}"> 
                          <router-link to="/emailsettings"><i class="la la-at"></i> <span>Email Settings</span></router-link>
                        </li>
                        <li class="performancesettings" :class="{'active': currentpage === 'performancesettings'}"> 
                          <router-link to="/performancesettings"><i class="la la-bar-chart-o"></i> <span>Performance Settings</span></router-link>
                        </li>
                        <li class="approvalsettings" :class="{'active': currentpage === 'approvalsettings'}"> 
                          <router-link to="/approvalsettings"><i class="la la-thumbs-up"></i> <span>Approval Settings</span></router-link>
                        </li>
                        <li class="invoicesettings" :class="{'active': currentpage === 'invoicesettings'}"> 
                          <router-link to="/invoicesettings"><i class="la la-pencil-square"></i> <span>Invoice Settings</span></router-link>
                        </li>
                        <li class="salarysettings" :class="{'active': currentpage === 'salarysettings'}"> 
                          <router-link to="/salarysettings"><i class="la la-money"></i><span>Salary Settings</span></router-link>
                        </li>
                        <li class="notificationssettings" :class="{'active': currentpage === 'notificationssettings'}"> 
                          <router-link to="/notificationssettings"><i class="la la-globe"></i> <span>Notifications</span></router-link>
                        </li>
                        <li class="changepassword" :class="{'active': currentpage === 'changepassword'}"> 
                          <router-link to="/changepassword"><i class="la la-lock"></i> <span>Change Password</span></router-link>
                        </li>
                        <li class="leavetype" :class="{'active': currentpage === 'leavetype'}"> 
                          <router-link to="/leavetype"><i class="la la-cogs"></i> <span>Leave Type</span></router-link>
                        </li>
                        <li class="leavetype" :class="{'active': currentpage === 'toxboxsettings'}"> 
                          <router-link to="/toxboxsettings"><i class="la la-comment"></i> <span>ToxBox Settings</span></router-link>
                        </li>
                         <li class="leavetype" :class="{'active': currentpage === 'cronsettings'}"> 
                          <router-link to="/cronsettings"><i class="la la-rocket"></i> <span>Cron Settings</span></router-link>
                        </li>
                    </ul>
                </div>
            </vue-custom-scrollbar>
        </div>
        <!-- Sidebar -->
    </div>
</template>
<script>  
import vueCustomScrollbar from 'vue-custom-scrollbar'
  import "vue-custom-scrollbar/dist/vueScrollbar.css"
  export default {
    components: {
      vueCustomScrollbar
    },
    computed: {
      currentpage() {
        return this.$route.name;
      },
    },
  data() {
    return {settings: {
suppressScrollX: false,
},
        activeClass: 'active',
    };
            //  isactive : true
  },
  methods: {
    scrollHanle(evt) {
      console.log(evt)
    }
  },
        }
       
        </script>
<style> 
 .scroll-area {
            position: relative;
            margin: auto;
            height: calc(100vh - 60px);
            background-color: transparent !important;
        }
  .sidebar {
    height: 100vh;
      overflow: auto;
  }
  
  .sidebar::-webkit-scrollbar {
    width: 7px;
  }
  
  /* Track */
  .sidebar::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 5px grey;  */
    box-shadow: none;
    border-radius: 10px;
  }
   
  /* Handle */
  .sidebar::-webkit-scrollbar-thumb {
    /* background: red;  */
    border-radius: 10px;
    /* background: rgb(204, 204, 204); */
    background-color: transparent;
  }
  
  /* Handle on hover */
  .sidebar::-webkit-scrollbar-thumb:hover {
    /* background: #b30000;  */
    background: rgb(204, 204, 204);
  }
  .sidebar-menu ul ul a.class-active {
  color: #00c5fb;
  text-decoration: underline;
}
  </style> 
  


// WEBPACK FOOTER //
// src/components/layouts/SidebarPromotion.vue